export default __webpack_public_path__ + "static/media/ic_Hamburger_menu.d256b6b5.svg";